module.exports = __webpack_public_path__ + "static/media/emptyState.4d81282f.svg";